/**
 * @flow
 *
 * This file configures the Redux store
 *
 * To keep things simple, and because Firebase already acts as a state management solution,
 * we are only using Redux for the following:
 *
 * 1) `redux-form` integration
 * 2) Basic UI state, i.e. the loading modal
 */
import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';

import uploadImageDatasourceReducer from './reducers/uploadImageDatasourceReducer'
import sensorDataReducer from './reducers/sensorDataReducer'

const appReducer = combineReducers({
  UploadImageData: uploadImageDatasourceReducer,
  SensorData: sensorDataReducer
});

const rootReducer = (state, action) => appReducer(state, action);


const store = createStore(rootReducer, applyMiddleware(ReduxThunk));
export default store;
